import {ConditionBase} from "./ConditionBase";
import {RNDatePicker} from "shared/controls/SingleInputs/RNDatePicker/RNDatePicker";
import {Condition} from "../AdvancedSearchControls";
import * as React from "react";

export class DateCondition extends ConditionBase{
    GetComparisons(): { Label: string; Value: string }[] {
        return [
            {Label:'Equal',Value:'='},
            {Label:'Not Equal',Value:'<>'},
            {Label:'Greater than',Value:'>'},
            {Label:'Greater or equal than',Value:'>='},
            {Label:'Less than',Value:'<'},
            {Label:'Less or equal than',Value:'<='}

        ];
    }

    GetValueEditor(condition:Condition,callback:()=>void): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        return <RNDatePicker style={{width:'100%'}} Value={condition.Value} onChange={x=>{condition.Value=x;callback()}}/>;
    }

}